// extracted by mini-css-extract-plugin
export default {"cardRoot":"styles_cardRoot__ZxM+H","listContainer":"styles_listContainer__Vxgk+","cardFooter":"styles_cardFooter__3y8LX"};